export const state = {
  theme: 1
};

export const mutations = {
  SWITCH_THEME(state,theme){
    state.theme = theme;
  }
};

export const actions = {};

export const getters = {};



// WEBPACK FOOTER //
// ./src/store/application.js